import { createAsyncThunk } from '@reduxjs/toolkit';

import * as FeaturesApi from '@sophocles/api/features';

export const loadFeatures = createAsyncThunk('features/load', async (_, { rejectWithValue }) => {
  try {
    const data = await FeaturesApi.fetchFeatures();
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const loadCustomerFeatureAssociations = createAsyncThunk(
  'features/customer/load',
  async (customerId, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.fetchFeatureAssociations({
        entity_id: customerId,
        entity_type: 'customer',
      });
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadSiteGroupFeatureAssociations = createAsyncThunk(
  'features/site-group/load',
  async (siteGroupId, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.fetchFeatureAssociations({
        entity_id: siteGroupId,
        entity_type: 'sitegroup',
      });
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadSiteFeatureAssociations = createAsyncThunk(
  'features/site/load',
  async (siteId, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.fetchFeatureAssociations({
        entity_id: siteId,
        entity_type: 'site',
      });
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const createFeatureAssociation = createAsyncThunk(
  'features/association/create',
  async ({ entity_id, entity_type, feature_key }, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.postFeatureAssociation({
        entity_id,
        entity_type_model: entity_type,
        feature_key: feature_key,
      });
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editFeatureAssociation = createAsyncThunk(
  'features/association/edit',
  async ({ id, is_enabled, default_enabled_for_children }, { rejectWithValue }) => {
    try {
      const patchData = {};
      if (is_enabled !== undefined) patchData.is_enabled = is_enabled;
      if (default_enabled_for_children !== undefined)
        patchData.default_enabled_for_children = default_enabled_for_children;

      const data = await FeaturesApi.patchFeatureAssociation(id, patchData);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const deleteFeatureAssociation = createAsyncThunk(
  'features/association/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.deleteFeatureAssociation(id);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const bulkFeatureAction = createAsyncThunk(
  'features/bulkAction',
  async ({ featureKey, entityType, entityId, action }, { rejectWithValue }) => {
    try {
      const data = await FeaturesApi.postFeatureBulkAction({
        feature_key: featureKey,
        entity_type: entityType,
        entity_id: entityId,
        action: action,
      });
      return data;
    } catch (e) {
      return rejectWithValue(e.response?.data ?? { error: 'Unknown error' });
    }
  },
);

// export const enableCustomerFeature = createAsyncThunk(
//   'features/customer/enable',
//   async ({ customerId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.postCustomerFeatureAction(customerId, 'enable', featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );

// export const disableCustomerFeature = createAsyncThunk(
//   'features/customer/disable',
//   async ({ customerId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.postCustomerFeatureAction(customerId, 'disable', featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );

// export const deleteCustomerFeature = createAsyncThunk(
//   'features/customer/delete',
//   async ({ customerId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.deleteCustomerFeature(customerId, featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );

// export const loadSiteFeatures = createAsyncThunk('features/site/load', async (siteId, { rejectWithValue }) => {
//   try {
//     const data = await FeaturesApi.fetchSiteFeatures(siteId);
//     return data;
//   } catch (e) {
//     return rejectWithValue(e.response.data);
//   }
// });

// export const enableSiteFeature = createAsyncThunk(
//   'features/site/enable',
//   async ({ siteId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.postSiteFeatureAction(siteId, 'enable', featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );

// export const disableSiteFeature = createAsyncThunk(
//   'features/site/disable',
//   async ({ siteId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.postSiteFeatureAction(siteId, 'disable', featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );

// export const deleteSiteFeature = createAsyncThunk(
//   'features/site/delete',
//   async ({ siteId, featureId }, { rejectWithValue }) => {
//     try {
//       const data = await FeaturesApi.deleteSiteFeature(siteId, featureId);
//       return data;
//     } catch (e) {
//       return rejectWithValue(e.response.data);
//     }
//   },
// );
